import GlobalStyle from './GlobalStyle';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './LoginPage';
import TranslationPage from './TranslationPage';
import PrivateRoute from './PrivateRoute';

const App = () => (
  <Router>
    <GlobalStyle />
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />
      {/* Routes protégées */}
      <Route element={<PrivateRoute />}>
        <Route path="/translation" element={<TranslationPage />} />
      </Route>
    </Routes>
  </Router>
);

export default App;
